import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { customPaymentMethods } from "@jti/fe-common";
import { deletePaymentTokenFromStorage, getPgsAdapter, getPgsPaymentMethods, getPGSToken, selectOrderNumber, useDispatch, useSelector, } from "@jti/store";
import { PaymentMethodSelector } from "../../../../components/PaymentMethodSelector";
import usePgsClient from "../../../../hooks/payment/usePgsClient";
import { useFreeTrial } from "../../../../hooks/useFreeTrial";
import usePaymentMethods from "../../../../hooks/usePaymentMethods";
import { useSubscription } from "../../../../hooks/useSubscription";
export const PaymentPagePaymentMethodsContainer = forwardRef(({ paymentMethodCode, handlePaymentMethodChange }, ref) => {
    const { orderId } = useParams();
    const dispatch = useDispatch();
    const { isSubscription } = useSubscription();
    const { paymentMethods, hasOrderError, pgsNewOrderPaymentToken, orderPending } = usePaymentMethods();
    const { isFreeTrial } = useFreeTrial();
    const orderEntityId = useSelector(selectOrderNumber(isFreeTrial));
    const shouldFetchPgsPaymentToken = orderEntityId && !pgsNewOrderPaymentToken && !orderPending;
    useEffect(() => {
        if (shouldFetchPgsPaymentToken) {
            dispatch(getPGSToken({ orderEntityId, isFreeTrial, isSubscription }));
        }
    }, [orderEntityId, dispatch, getPGSToken, shouldFetchPgsPaymentToken]);
    useEffect(() => {
        dispatch(getPgsPaymentMethods());
    }, [dispatch]);
    // TODO DESP-82430: remove using this hook here. It is used in PaymentPageFooter directly
    usePgsClient({
        ref,
        paymentCode: paymentMethodCode,
        onUnmount: deletePaymentTokenFromStorage,
        buttonClassName: "payButton",
        orderEntityId,
        orderId,
    });
    const handleSelect = useCallback(async (code) => {
        if (code) {
            handlePaymentMethodChange(code);
            if (code !== customPaymentMethods.payOnDelivery) {
                dispatch(getPgsAdapter({ code }));
            }
        }
    }, [dispatch]);
    return hasOrderError ? null : _jsx(PaymentMethodSelector, { methods: paymentMethods, onSelect: handleSelect });
});
//# sourceMappingURL=PaymentPagePaymentMethodsContainer.js.map